import create from '../modules/create/reducer.js';
import listing from '../modules/listing/reducer.js';
import locale from '../modules/locale/reducer.js';
import event from '../modules/event/reducer.js';
import nav from '../modules/nav/reducer.js';
import session from '../modules/session/reducer.js';
import dashboard from '../modules/dashboard/reducer.js';
import myEvents from '../modules/my-events/reducer.js';
import myTickets from '../modules/my-tickets/reducer.js';
import profile from '../modules/profile/reducer.js';
import modal from '../modules/modal/reducer.js';
import paymentPlan from '../modules/payment-plans/reducer.js';
import stripe from '../modules/stripe/reducer.js';
import yourOrder from '../modules/your-order/reducer.js';
import yourTicket from '../modules/your-ticket/reducer.js';
import invoice from '../modules/invoice/reducer.js';
import betaDashboard from '../modules/beta-dashboard/reducers.js';
import reports from '../modules/reports/reducers.js';
import organizationSelect from '../modules/organization-select/reducer.js';
import codes from '../modules/codes/reducer.js';

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  create,
  listing,
  locale,
  event,
  nav,
  session,
  dashboard,
  myEvents,
  myTickets,
  profile,
  modal,
  paymentPlan,
  stripe,
  yourOrder,
  yourTicket,
  invoice,
  betaDashboard,
  reports,
  organizationSelect,
  codes
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js